$(document).ready(function () {
  $(".hamburger").on("click", function () {
    $(this).toggleClass("clicked");
    $(".navigation-overlay").toggleClass("display");
    $(".nav-logo-icon").fadeToggle();
    $("body").toggleClass("overflow-hidden");
  });
});
